import { getItemFromStorage } from "../../helper/storage";
import {
  expectedScoresRequest,
  expectedScoresRequestFailed,
  expectedScoresRequestSucceeded,
  personTopicSummaryRequest,
  personTopicSummaryRequestFailed,
  personTopicSummaryRequestSucceeded,
  topicEvolutionFilteredRequest, topicEvolutionFilteredRequestFailed, topicEvolutionFilteredRequestSucceeded,
  topicEvolutionRequest,
  topicEvolutionRequestFailed,
  topicEvolutionRequestSucceeded,
  topicsProgressionByMonthRequest,
  topicsProgressionByMonthRequestFailed,
  topicsProgressionByMonthRequestSucceeded
} from "../action-creators/topics";
import { apiListExpectedScores } from "../api/expectedScoreApi";
import { apiPersonTopicSummaryRequest, apiTopicEvolution, apiTopicEvolutionFilteredRequest, apiTopicsProgressionByMonthRequest } from "../api/topics";

const createTopicsProgressionByMonthRequest = (filters) => dispatch => {
  dispatch(topicsProgressionByMonthRequest());
  const company_id = getItemFromStorage("COMPANY_ID");
  const token = getItemFromStorage("TOKEN");
  return apiTopicsProgressionByMonthRequest(token, company_id, filters).then(json => {
    dispatch(topicsProgressionByMonthRequestSucceeded(json));
    return Promise.resolve();
  }).catch(response => {
    dispatch(topicsProgressionByMonthRequestFailed());
    return Promise.reject();
  })
};

export const getTopicsProgressionByMonth = (filters) => dispatch => dispatch(createTopicsProgressionByMonthRequest(filters));

const createAbilitiesRequest = topic_id => dispatch => {
  dispatch(topicEvolutionRequest());
  const company_id = getItemFromStorage("COMPANY_ID");
  const token = getItemFromStorage("TOKEN");

  return apiTopicEvolution(token, company_id, topic_id)
    .then(json => {
      dispatch(topicEvolutionRequestSucceeded(json));
      return Promise.resolve();
    }).catch(response => {
      dispatch(topicEvolutionRequestFailed(response));
      return Promise.reject();
    })
};
export const getTopicEvolution = topic_id => dispatch => dispatch(createAbilitiesRequest(topic_id));

const createAbilitiesFilteredRequest = (topic_id, filters) => dispatch => {
  dispatch(topicEvolutionFilteredRequest());
  const company_id = getItemFromStorage("COMPANY_ID");
  const token = getItemFromStorage("TOKEN");

  return apiTopicEvolutionFilteredRequest(token, company_id, topic_id, filters)
    .then(json => {
      dispatch(topicEvolutionFilteredRequestSucceeded(json));
      return Promise.resolve(json);
    }).catch(response => {
      dispatch(topicEvolutionFilteredRequestFailed(response));
      return Promise.reject();
    })
};
export const getTopicFilteredEvolution = (topic_id, filters) => dispatch => dispatch(createAbilitiesFilteredRequest(topic_id, filters));

const createPersonTopicSummaryRequest = (personId, page = 1) => dispatch => {
  dispatch(personTopicSummaryRequest())
  const token = getItemFromStorage("TOKEN");
  return apiPersonTopicSummaryRequest(token, personId, page).then(json => {
    dispatch(personTopicSummaryRequestSucceeded(json));
    return Promise.resolve();
  }).catch((error) => {
    dispatch(personTopicSummaryRequestFailed(error))
    return Promise.reject();
  });
}
export const topicPersonSummary = (personId, page = 1) =>
  dispatch => dispatch(createPersonTopicSummaryRequest(personId, page));

const createExpectedScoresRequest = (topicId) => dispatch => {
  dispatch(expectedScoresRequest());

  return apiListExpectedScores({ topic_id: topicId })
    .then(json => {
      dispatch(expectedScoresRequestSucceeded(json));
      return Promise.resolve(json);
    }).catch(response => {
      dispatch(expectedScoresRequestFailed(response));
      return Promise.reject(response);
    })
};

export const getExpectedScores = (topicId) => dispatch => dispatch(createExpectedScoresRequest(topicId));
